// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"984b876b","821":"845eaefc"}[chunkId] + ".chunk.js";
};